export default "__VITE_ASSET__CRYHA5s0__"